/** Survey sections on the Surveys page, in display order. `type` is `survey_questions.survey_type`. */
export const SURVEY_SECTIONS = [
    { type: 'LOAD_FEEDBACK', title: 'Inbound Load Surveys' },
    { type: 'PREDELIVERY', title: 'Pre-delivery Surveys' },
    { type: 'DRIVER', title: 'Driver Surveys' },
    { type: 'POSTDELIVERY', title: 'Post-delivery Surveys' },
];
